module.exports = __webpack_public_path__ + "f03300f2b49b13f6e455aaae7d7a0136.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sct/Logo_SMARTCorporateTravel.svg
// module id = 6
// module chunks = 1